export default __webpack_public_path__ + "static/Qualitas-22ba2e627067c076a4f5f1f27ad4ad2e.svg";